import listComponent from '@/util/proto/listComponent'
import ExamPaper from './exam-paper'

export default {
  extends: listComponent,
  props:['id'],
  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          align:'center',
          width: 60,
        },
        {
          title: '申请时间',
          key: 'applyDatetimeText',
        },
        
        {
          title: '成绩',
          key: 'score',
        },
        {
          title: '考试时间',
          key: 'startDatetimeText',
        },
        {
          title: '结果',
          key: 'resultText',
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: "right",
          align: 'center',
          render: (h, { row }) => {
            //状态：0、申请中，1、待开始考试，2、考试中，3，考试完成，4、申请不通过，5、驾照已经发放，6、待申请

            // if(row.score !== null){
              return this.$utils.link([<a on-click={()=>this.view(row)}>查看试卷</a>], <Divider type="vertical" />)
            // }
          }
        }
      ],
      options:{},
      data: [],
      visible:false,
    }
  },

  created(){
    this.$watch('id' , function(nv){
      if(nv){
        this.search()
      }else{
        this.data = []
      }
    },{immediate:true})
    
  },
  methods: {
    search(){
      let params = { search:{courierId:this.id}, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true
      this.$request.licenseExamRecords(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list || [] , {'applyDatetime':'datetime', 'result':'examResult' , 'examType':'examTplType' , 'startDatetime':'datetime'})
        this.page.total = resp.data.total
      })
    },
    view(row){
      this.$dialog({
        title: '查看试卷',
        fullscreen:true,
        paddingless: true,
        render: (h) => {
          return <ExamPaper id={row.id} />
        }
      })
    }
  },

  render(){
    const data = this.data || {}

    return <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />
  }
}
